import { TOGGLE_KANA_SWITCH } from "./types";

export const toggleKanaSwitch = () => {
  return {
    type: TOGGLE_KANA_SWITCH
  }
}